import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { Refresh, BugReport, ErrorOutline } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
    
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReportBug = () => {
    const errorReport = {
      error: this.state.error?.toString(),
      stack: this.state.error?.stack,
      componentStack: this.state.errorInfo?.componentStack,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      url: window.location.href
    };
    
    console.log('Bug Report:', errorReport);
    // In production, send to error reporting service
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 4,
            textAlign: 'center'
          }}
        >
          <ErrorOutline sx={{ fontSize: '6rem', color: 'error.main', mb: 2 }} />
          
          <Typography variant="h4" gutterBottom>
            Oops! Etwas ist schiefgelaufen
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 600 }}>
            Es tut uns leid, aber es ist ein unerwarteter Fehler aufgetreten. 
            Bitte versuche die Seite neu zu laden oder kontaktiere uns, wenn das Problem weiterhin besteht.
          </Typography>

          {process.env.NODE_ENV === 'development' && (
            <Alert severity="error" sx={{ mb: 4, maxWidth: 800, textAlign: 'left' }}>
              <Typography variant="subtitle2" gutterBottom>
                Development Error Details:
              </Typography>
              <Typography variant="body2" component="pre" sx={{ fontSize: '0.75rem', overflow: 'auto' }}>
                {this.state.error && this.state.error.toString()}
                {this.state.errorInfo.componentStack}
              </Typography>
            </Alert>
          )}

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              variant="contained"
              startIcon={<Refresh />}
              onClick={this.handleReload}
              size="large"
            >
              Seite neu laden
            </Button>
            
            <Button
              variant="outlined"
              startIcon={<BugReport />}
              onClick={this.handleReportBug}
              size="large"
            >
              Fehler melden
            </Button>
          </Box>

          <Typography variant="caption" color="text.secondary" sx={{ mt: 4 }}>
            HelpBook v{process.env.REACT_APP_VERSION || '3.0.0'}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
